import React, { PropsWithChildren } from 'react';

import { DealBuilderContextValue } from './types';
import { dealBuilderContext as DealBuilderContext } from './dealBuilderContext';

export const DealBuilderContextProvider = ({
  value,
  children,
}: PropsWithChildren<{ value: DealBuilderContextValue }>) => (
  <DealBuilderContext.Provider value={value}>{children}</DealBuilderContext.Provider>
);
